<div class="header">
    <h2>{{ 'instructors.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="instructors-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'instructors.error.unavailable' | translate" />
} @else if (instructor(); as instructor) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-avatar">
                <app-avatar [image]="instructor.imageMediaId | mediaSrc | async" [label]="instructor.firstName | initials: instructor.lastName" size="lg" />
            </div>
            <div class="entity-identity">
                <h1>{{ instructor.firstName }} {{ instructor.lastName }}</h1>
            </div>
        </div>

        <div class="meta-strip">
            <div class="meta-item">
                <span class="meta-label">{{ 'instructors.form.degree' | translate }}</span>
                @if (instructor.degree) {
                    <span class="meta-value">{{ instructor.degree }}</span>
                } @else {
                    <span class="meta-value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="meta-item">
                <span class="meta-label">{{ 'instructors.form.university' | translate }}</span>
                @if (instructor.university) {
                    <span class="meta-value">{{ instructor.university }}</span>
                } @else {
                    <span class="meta-value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="meta-item">
                <span class="meta-label">{{ 'instructors.form.updatedAt' | translate }}</span>
                <span class="meta-value">{{ instructor.updatedAt | date: 'mediumDate' }}</span>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-delete-button [instructorId]="instructor.id" [saving]="saving()" testId="instructors-view-delete" />
        <p-button [label]="'instructors.detail.edit' | translate" icon="pi pi-pencil" data-test="instructors-view-edit" (onClick)="onEdit()" />
    </div>
}
